/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * How to deliver the code
 */
export enum SendOtpBodyChannel {
  sms = 'sms',
  call = 'call'
}
